import React, { Fragment, useEffect, useState } from "react";
import { withRouter, Route, Switch } from "react-router-dom";
import EnterPhone from "../Components/Entrance/EnterPhone";
import Homepage from "../Components/Education/Homepage";
import Category from "../Components/Education/Category";
// import Content from '../Components/Education/content';
import Coursecnt from "../Components/Education/Coursecontent";
import PdfViewer from "../Components/Education/PdfViewer";
import Mycourses from "../Components/Education/Mycourses";
import MyLotteryDetails from "../Components/Profile/Lottery/myLotteryDetails";
import MainPage from "../Components/MainPage/MainPage";
import News from "../Components/News/News";
import Innernews from "../Components/News/Innernews";
import Profile from "../Components/Profile/Profile";
import Entrnace from "../Components/Entrance/Entrance";
import MainMenu from "../Components/Common/MainMenu";
import EditInformation from "../Components/Profile/EditInformation/EditInformation";
import ArchiveDetail from "../Components/Profile/Lottery/ArchiveDetail";
import Error404 from "../Components/Common/404Error";
// Exam
import Exam from "../Components/Exam/Exam";
import ExamResults from "../Components/Exam/ExamResults";
// Awards
import Awards from "../Components/Award/award";
// Lottery
import LotteryDetail from "../Components/Profile/Lottery/LotteryDetail";
// Licence
import Licence from "../Components/Profile/Licence/Licence";
// Webinar
import Webinar from "../Components/Profile/Webinar/Webinar";
import InnerWebinar from "../Components/Profile/Webinar/InnerWebina";
// Scores
import Scores from "../Components/Profile/Scores/MyScores";
// Tickets
import Tickets from "../Components/Profile/Tickets/Tickets";
import TicketDetail from "../Components/Profile/Tickets/TicketDetail";
import NewtTicket from "../Components/Profile/Tickets/NewTicket";
import ReplayedTicket from "../Components/Profile/Tickets/replayTiket";
// MyCourses
import MyCoursesProfile from "../Components/Profile/MyCourses/MyCourse";
// Recomandation
import Recomandation from "../Components/Recomandation/Recomandation";
// AdminLogin
import AdminLogin from "../Components/adminLogin/index";
// Notification
import Notification from "../Components/Profile/notification/notification";
// AboutUs
import AboutUs from "../Components/aboutUs/aboutUs";
// ContactUs
import ContactUs from "../Components/contactUs/contact";
// roles
import Roles from "../Components/roles/roles";
// config notification
import NotificationConfig from "./notification.config";
// AppContext
import { AppContext } from "./AppContext";
import ExamList from "../Components/Exam/ExamList";
import EndedExam from "../Components/Exam/EndedExam";

const MainBody = (props) => {
  const [contextStore, setContextStore] = useState({
    userScore: "",
  });
  NotificationConfig();

  // check devices for redirect to pwa-version
  const ua = navigator.userAgent;
  const deviceTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
    ua
  );
  const deviceMobile =
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    );
  if (deviceTablet || deviceMobile) {
    window.location.replace("https://pwa.s-plus.ir");
  }

  // check show menu
  const allowDisplay_MainMenu = () => {
    const currentSection = props.match.params.section;
    const forbiddenSections = ["entrance", "404"];
    if (
      (currentSection === undefined && !localStorage.getItem("logined")) ||
      forbiddenSections.indexOf(currentSection) !== -1
    ) {
      return false;
    }
    return true;
  };

  // check log-in
  const checkLogin = () => {
    return localStorage.getItem("logined") !== null;
  };
  return (
    <Fragment>
      <AppContext.Provider value={{ contextStore, setContextStore }}>
        {/* {allowDisplay_MainMenu() && <MainMenu />} */}
        {!allowDisplay_MainMenu() ||
        localStorage.getItem("logined") == null ? null : (
          <MainMenu />
        )}
        <Switch>
          <Route exact path="/entrance/:step?" component={Entrnace} />
          {/* education */}
          <Route
            exact
            path="/education"
            component={checkLogin() ? Homepage : EnterPhone}
          />
          <Route
            exact
            path="/education/category/:pg?/:isHome?"
            component={checkLogin() ? Category : EnterPhone}
          />
          <Route
            exact
            path="/education/course-content/:id?"
            component={checkLogin() ? Coursecnt : EnterPhone}
          />
          <Route
            exact
            path="/education/course-content/:id?/pdfViewer"
            component={checkLogin() ? PdfViewer : EnterPhone}
          />
          <Route
            exact
            path="/education/mycourses/:id?"
            component={checkLogin() ? Mycourses : EnterPhone}
          />
          {/* award */}
          <Route
            exact
            path="/award"
            component={checkLogin() ? Awards : EnterPhone}
          />
          {/* main-page */}
          <Route
            exact
            path="/"
            component={checkLogin() ? MainPage : EnterPhone}
          />
          {/* news */}
          <Route
            exact
            path="/news"
            component={checkLogin() ? News : EnterPhone}
          />
          <Route
            exact
            path="/news/inner-page/:id?"
            component={checkLogin() ? Innernews : EnterPhone}
          />
          <Route
            exact
            path="/editInformation"
            component={checkLogin() ? EditInformation : EnterPhone}
          ></Route>
          {/* exam */}
          <Route
            exact
            path="/exam"
            component={checkLogin() ? Exam : EnterPhone}
          ></Route>
          <Route
            exact
            path="/examResults"
            component={checkLogin() ? ExamResults : EnterPhone}
          ></Route>
          {/* profile */}
          <Route
            exact
            path="/profile"
            component={checkLogin() ? Profile : EnterPhone}
          />
          <Route
            exact
            path="/profile/EditInformation"
            component={checkLogin() ? EditInformation : EnterPhone}
          />
          {/* Scores */}
          <Route
            exact
            path="/MyScores"
            component={checkLogin() ? Scores : EnterPhone}
          ></Route>
          {/* my-Lottery */}
          <Route
            exact
            path="/Lottery"
            component={checkLogin() ? MyLotteryDetails : EnterPhone}
          />
          <Route
            exact
            path="/Lottery/LotteryDetail/:id?"
            component={checkLogin() ? LotteryDetail : EnterPhone}
          />
          <Route
            exact
            path="/Lottery/LotteryExpire/:id?"
            component={checkLogin() ? ArchiveDetail : EnterPhone}
          />
          {/* my-Licence */}
          <Route
            exact
            path="/Licence"
            component={checkLogin() ? Licence : EnterPhone}
          ></Route>
          {/* my-Webinar */}
          <Route
            exact
            path="/Webinar"
            component={checkLogin() ? Webinar : EnterPhone}
          ></Route>
          <Route
            exact
            path="/Webinar/InnerWebinar/:id?"
            component={checkLogin() ? InnerWebinar : EnterPhone}
          ></Route>
          {/* my-Tickets */}
          <Route
            exact
            path="/Tickets"
            component={checkLogin() ? Tickets : EnterPhone}
          ></Route>
          <Route
            exact
            path="/Tickets/InnerPage/:id?"
            component={checkLogin() ? TicketDetail : EnterPhone}
          ></Route>
          <Route
            exact
            path="/Tickets/CreateTicket"
            component={checkLogin() ? NewtTicket : EnterPhone}
          ></Route>
          <Route
            exact
            path="/Tickets/ReplayedTicket/:id?"
            component={checkLogin() ? ReplayedTicket : EnterPhone}
          ></Route>
          {/* my-courses */}
          <Route
            exact
            path="/MyCourses"
            component={checkLogin() ? MyCoursesProfile : EnterPhone}
          ></Route>
          {/* my-Licence */}
          <Route
            exact
            path="/MyLicence"
            component={checkLogin() ? Licence : EnterPhone}
          ></Route>
          {/* recomandation-courses */}
          <Route
            exact
            path="/recomandationCourses"
            component={checkLogin() ? Recomandation : EnterPhone}
          ></Route>
          {/* Notification*/}
          <Route path="/Notifications" component={Notification} />
          {/* admin login */}
          <Route path="/redirect-to-user/:id?" component={AdminLogin} />
          {/* about us */}
          <Route path="/about-us" component={AboutUs} />
          {/* contact us */}
          <Route path="/contact-us" component={ContactUs} />
          {/* roles */}
          <Route path="/roles" component={Roles} />
          {/* 404 */}
          <Route path="/404" component={Error404} />
          {/* <Redirect to="/404" /> */}
          <Route exact path="/examList" component={ExamList} />
          <Route exact path="/examList/ended-exam/:id" component={EndedExam} />
        </Switch>
      </AppContext.Provider>
    </Fragment>
  );
};

export default withRouter(MainBody);
